import styled from "styled-components";

const OrbitalErrorDiv = styled.div`
    margin-top: 0,25rem;
    font-size: 80%;
    color: #dc3545;
`;

export default OrbitalErrorDiv;